import { loadNostrUser, NostrUser } from '@nostr/gadgets/metadata'
import { atom, useAtomValue } from 'jotai'
import { unwrap } from 'jotai/utils'
import { currentPubkeyAtom } from './session'
import { metadataChannelAtom } from './invalidation'
import client from '@/services/client.service'

// holds the current logged-in user's NostrUser profile
// loaded automatically whenever currentPubkeyAtom becomes non-null
export const currentProfileAtom = atom(async (get) => {
  const pubkey = get(currentPubkeyAtom)
  get(metadataChannelAtom)

  if (!pubkey) return null
  const profile = await loadNostrUser({
    pubkey,
    relays: [
      ...window.hallway.universe.bigRelayUrls,
      ...window.hallway.universe.profileSearchRelayUrls
    ],
    refreshStyle: true
  })
  if (profile) client.addUsernameToIndex(profile)
  return profile
})
export const unwrappedCurrentProfileAtom = unwrap(currentProfileAtom)

export function useCurrentProfile(): NostrUser | null {
  return useAtomValue(unwrappedCurrentProfileAtom) ?? null
}
